export const TICKET_CLIENTS = {
  EKO: 'Eko',
  CODITAS: 'Coditas',
  EKO_C: 'EKO CLIENT',
  CODITASC: 'CODITAS',
  LICENSES: 'LICENSES',
  Licenses: 'Licenses',
  LICENSING: 'LICENSING',
  License: 'License'
}

export type TeamTab = 'Active' | 'Pending' | 'Expired' | 'Revoked' | 'Declined' | 'All';

export const TEAM_TABS: TeamTab[] = ['Active', 'Pending', 'Expired', 'Revoked', 'Declined', 'All'];

export const TEAM_TAB_STATUS_MAP: Record<TeamTab, string | undefined> = {
  Active:   'ACTIVE',
  Pending:  'PENDING',
  Expired:  'EXPIRED',
  Revoked:  'REVOKED',
  Declined: 'DECLINED',
  All:      undefined,
};

export const TEAM_EMPTY_TITLES: Record<TeamTab, string> = {
  Active:   'No active requests',
  Pending:  'No pending requests',
  Expired:  'No expired requests',
  Revoked:  'No revoked requests',
  Declined: 'No declined requests',
  All:      'No team access records found',
};

export const TEAM_EMPTY_SUBTITLES: Record<TeamTab, string> = {
  Active:   'There are no active tool / access requests',
  Pending:  'There are no pending tool / access requests.',
  Expired:  'There are no expired tool / access records.',
  Revoked:  'There are no revoked tool / access records.',
  Declined: 'There are no declined tool / access records.',
  All:      'There are no tool / access records to display.'
};
